import { PivotTableCaptions, PivotTableFields, PivotTableGroup } from '@types'

import { GRAND_TOTAL_CAPTION } from './const'

export const getSectionCounts = (fields: PivotTableFields | undefined, section: PivotTableGroup) => {
  const inSection = Object.values(fields || {}).filter(field => field.group === section)
  return {
    enabled: inSection.filter(field => field.enabled).length,
    total: inSection.length,
  }
}

export const getFieldCaption = (field: string, caption?: PivotTableCaptions[string]) => {
  if (field === 'footer_grand_total') return GRAND_TOTAL_CAPTION
  return caption || field.at(0)?.toUpperCase() + field.slice(1)
}
